import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Global } from './global';
import { AsapEditComponent } from './asap-edit.component';
import { MatFormFieldModule, MatInputModule, MatButtonModule, MatSnackBarModule, MatSnackBar } from '@angular/material';
import { AsapService } from './asap.service';
import { AsapTimePickerComponent } from './asap-time-picker.component';
import { ToastComponent } from './toast/toast.component';
import { UploadModule } from 'app/modules/shared/upload/upload.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatSnackBarModule,
        ReactiveFormsModule,
        UploadModule
    ],
    declarations: [
        ToastComponent,
        AsapEditComponent,
        AsapTimePickerComponent
    ],
    providers: [
        Global,
        AsapService
    ],
    exports: [
        MatSnackBarModule,
        AsapTimePickerComponent
    ],
    entryComponents: [
        AsapEditComponent,
        ToastComponent
    ]
})
export class AsapBaseModule {

}


// WEBPACK FOOTER //
// ./src/app/@core/lib/asap-base.module.ts